import { jsx as _jsx } from "react/jsx-runtime";
function IsotopesViewer({ value = '', ...othersProps }) {
    return (_jsx("div", { ...othersProps, 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: value.replace(/(?<isotope>\d+)/g, '<sup>$<isotope></sup>'),
        } }));
}
export default IsotopesViewer;
